import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { KbService } from "@app/services/kb.service";
import * as enums from "@models";

export interface IEnumFilter {
    (enumName: string, localize?: boolean):{ name: string; value: string; }[];
}

// declare module "angular" {
//     interface IFilterService {
//         (name: "enum"): IEnumFilter;
//     }
// }

/**
 * takes an enum type name and returns an array of name/value pairs
 * that have the localization representing the enum value as the name
 * and the value as the string value for the enum
 */
@NgFilter({
    token: Token.EnumFilter,
    dependencies: [
        Token.KbService
    ]
})
export class EnumFilter {
    constructor(
        kbService: KbService
    ) {
        return ((
            enumName: string,
            localize = true
        ) => {
            let enumType = enums[enumName];
            let results = [];
            for (let i in enumType) {
                let locTitle = enumType[i];
                let locDesc = null;
                if (localize) {
                    // get the localized value for the enum value.  This is convention based
                    let resxName = enumName + "_" + enumType[i] + "_title";
                    locTitle = kbService.loc(resxName);
                    // if we still have the resx name, then try to see if there is already a matching word
                    if (locTitle.isEqual(resxName)) {
                        let low = enumType[i].toLowerCase();
                        if (loc.hasOwnProperty(low)) {
                            locTitle = kbService.loc(low);
                        }
                    }

                    resxName = enumName + "_" + enumType[i] + "_desc";
                    locDesc = kbService.loc(resxName);
                }

                results.push({ name: locTitle, value: enumType[i], desc: locDesc });
            }
            return results;
        }) as any;
    }
}
